import { BEmbed } from './embed';
import { pluginFactory } from '../../utils/plugins';
var EmbedPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BEmbed: BEmbed
  }
});
export { EmbedPlugin, BEmbed };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_bootstrap-vue@2.6.1@bootstrap-vue/esm/components/embed/index.js
// module id = null
// module chunks = 